// export const BaseUrl = 'http://localhost:5200'
export const BaseUrl = 'https://api.memahijab.com'
